import React from "react"

interface ProjectLink {
  label: string
  href: string
}

interface ProjectItem {
  title: string
  eyebrow: string
  description: string
  links: ProjectLink[]
}

const projects: ProjectItem[] = [
  {
    title: "Zaman Takip",
    eyebrow: "Zaman Takip",
    description: "Günlük çalışma akışını daha düzenli takip etmeye odaklanan bir uygulama.",
    links: [
      {
        label: "Projeyi Aç",
        href: "https://zaman-takip.vercel.app",
      },
    ],
  },
]

const createProjectLink = ({ label, href }: ProjectLink) => (
  <a
    key={label}
    href={href}
    className="btn btn--primary"
    target="_blank"
    rel="noopener noreferrer"
  >
    {label}
  </a>
)

export const ProjectsShowcase = () => (
  <section className="projects">
    <div className="projects__hero">
      <div className="container projects__hero-container">
        <div className="projects__hero-copy">
          <span className="projects__eyebrow">Projeler</span>
          <h1>Projeler</h1>
        </div>

        <div className="projects__hero-preview" aria-hidden="true">
          <div className="projects__browser">
            <div className="projects__browser-bar">
              <span />
              <span />
              <span />
            </div>
            <div className="projects__browser-body">
              <div className="projects__metric-card">
                <small>Odak</small>
                <strong>Zaman Takibi</strong>
              </div>
              <div className="projects__metric-grid">
                <div>
                  <small>Oturum</small>
                  <strong>08:45</strong>
                </div>
                <div>
                  <small>İlerleme</small>
                  <strong>%72</strong>
                </div>
              </div>
              <div className="projects__progress">
                <span />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="projects__content">
      <div className="projects__list">
        {projects.map(({ title, eyebrow, description, links }) => (
          <article className="projects__card" key={title}>
            <div className="projects__card-visual">
              <img
                className="projects__card-image"
                src="/resim2.png"
                alt="Zaman Takip uygulama ekran görüntüsü"
              />
              <div className="projects__card-badge">{eyebrow}</div>
            </div>

            <div className="projects__card-body">
              <span className="projects__card-label">{eyebrow}</span>
              <h3>{title}</h3>
              <p>{description}</p>

              <div className="projects__actions">
                {links.map(createProjectLink)}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)
